import React from "react";

// Importing redux components
import { useSelector } from "react-redux";

import GeneralAccessManagement from "./GeneralAccess";

import WarningAlert from 'common/Alert';

// Import utilities
import { isAllowedToDoByKey } from 'permissions-hub';
import { ATTENDANCE_MANAGEMENT, HOLIDAY_MANAGEMENT, ACCEPTED_PERMISSIONS, PAYROLLNOTE_MANAGEMENT } from "constants";
import { getAllowedPermissions } from "utils/authentication";

const EmployeeDashboard = () => {

  const { userInfo: loggedUserInfo, } = useSelector((state) => state.auth);
  
  // Check read permission of attendance
  const isAllowedToReadAttendance = isAllowedToDoByKey(
    ATTENDANCE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // Check read permission of holiday
  const isAllowedToReadHoliday = isAllowedToDoByKey(
    HOLIDAY_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadPayrollNotes = isAllowedToDoByKey(
    PAYROLLNOTE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );
  
  return !( isAllowedToReadAttendance && isAllowedToReadHoliday ) ? (
    <WarningAlert 
      message="<p>In order to effectively manage the system, you need to have read permissions for <strong>Attendance & Holiday management</strong>. If you are an admin, you can enable these permissions from the role management section.</p>
      <hr/> <p class='mb-0'>If you need further assistance, please contact the developer at <a href='mailto:ankitbattersea@gmail.com' >ankitbattersea@gmail.com</a>.</p>" 
    />
  ) : (
    <GeneralAccessManagement isAllowedToReadPayrollNotes={isAllowedToReadPayrollNotes} />
  );
}

export default EmployeeDashboard;